<template>
  <fin-work-in-progess-page title="Index-Analyzer"/>
</template>

<script>
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: "FinIndexAnalyzer",
  components: {FinWorkInProgessPage}
}
</script>

<style scoped>

</style>
